module.exports = __webpack_public_path__ + "media/images/landing/word_map-59621c9b08dff78f650580d3c2282dce.png";